import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';

const AppNavbar = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const username = localStorage.getItem('username');
  const role = localStorage.getItem('role');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('role');
    localStorage.removeItem('userId');
    navigate('/');
  };

  return (
    <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/">EY代購</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/">首頁</Nav.Link>
            <Nav.Link as={Link} to="/products">商品列表</Nav.Link>
            {token ? (
              <>
                <Nav.Link as={Link} to="/cart">購物車</Nav.Link>
                <Nav.Link as={Link} to="/my-orders">我的訂單</Nav.Link>
                {role === 'admin' && (
                  <>
                    <Nav.Link as={Link} to="/admin/orders">管理訂單</Nav.Link>
                    <Nav.Link as={Link} to="/admin/products">管理產品</Nav.Link>
                    <Nav.Link as={Link} to="/admin/categories">管理分類</Nav.Link>
                  </>
                )}
                <Nav.Link as={Link} to="/" onClick={handleLogout}>登出</Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login">登入</Nav.Link>
                <Nav.Link as={Link} to="/register">註冊</Nav.Link>
              </>
            )}
            <Nav.Link as={Link} to="/contact-us">聯絡我們</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
